import React from 'react'

import InputV2 from 'components/InputV2'
import GhostRadioV2 from 'components/GhostRadioV2'
import ArrowIcon from 'containers/ProfileV2/images/ic-arrow.component.svg'

import {
  Form,
  FormInputs,
  InputsSection,
  CustomInputsRow,
  InputWrapper,
  RadiosWrapper,
  Error,
  WrapperSelect,
  StyledSelect,
  InputLabel,
} from './styles'

const PersonalForm = (props) => {
  const {
    name,
    surName,
    email,
    phone,
    nif,
    contact,
    contactTime,
    changeField,
    loading,
    tab,
    renderBtns,
  } = props

  const contactValues = [
    { label: '9h00 - 11h30', value: '9h00 - 11h30' },
    { label: '11h30 - 13h00', value: '11h30 - 13h00' },
    { label: '13h00 - 15h30', value: '13h00 - 15h30' },
    { label: '15h30 - 18h00', value: '15h30 - 18h00' },
    { label: '18h00 - 20h30', value: '18h00 - 20h30' },
  ]

  return (
    !loading &&
    tab === 'personal' && (
      <Form>
        <FormInputs>
          <InputsSection>
            <h4>Dados Pessoais</h4>

            <div className='rowsWrapper'>
              <CustomInputsRow>
                <InputWrapper>
                  <InputV2
                    id='name_input'
                    style={{ width: '100%' }}
                    required
                    label='Nome'
                    type='text'
                    placeholder='Escreva o seu nome'
                    value={name.value}
                    onChange={(val) => changeField('personal', 'name', val)}
                    valid={!Boolean(name.valid)}
                    errorMessage={name.valid}
                  />
                </InputWrapper>

                <InputWrapper>
                  <InputV2
                    id='surName_input'
                    style={{ width: '100%' }}
                    required
                    label='Apelido'
                    type='text'
                    placeholder='Escreva o seu apelido'
                    value={surName.value}
                    onChange={(val) => changeField('personal', 'surName', val)}
                    valid={!Boolean(surName.valid)}
                    errorMessage={surName.valid}
                  />
                </InputWrapper>
              </CustomInputsRow>

              <CustomInputsRow>
                <InputWrapper>
                  <InputV2
                    id='nif_input'
                    style={{ width: '100%' }}
                    required
                    label='NIF'
                    type='number'
                    placeholder='Ex: 000 000 000'
                    value={nif.value}
                    onChange={(val) => changeField('personal', 'nif', val)}
                    valid={!Boolean(nif.valid)}
                    errorMessage={nif.valid}
                  />
                </InputWrapper>
              </CustomInputsRow>
            </div>
          </InputsSection>

          <InputsSection>
            <h4>Contatos</h4>

            <div className='rowsWrapper'>
              <CustomInputsRow>
                <InputWrapper>
                  <InputV2
                    id='email_input'
                    style={{ width: '100%' }}
                    required
                    label='Email'
                    type='email'
                    placeholder='Escreva o seu email'
                    value={email.value}
                    onChange={(val) => changeField('personal', 'email', val)}
                    valid={!Boolean(email.valid)}
                    errorMessage={email.valid}
                  />
                </InputWrapper>

                <InputWrapper>
                  <InputV2
                    id='phone_input'
                    style={{ width: '100%' }}
                    required
                    label='Contato'
                    placeholder='Ex: 900 000 000'
                    value={phone.value}
                    valid={!Boolean(phone.valid)}
                    errorMessage={phone.valid}
                    onChange={(val) => {
                      let value = val
                      const sanitized = value.replace(/[^\d+]/g, '')

                      const plusCount = (sanitized.match(/\+/g) || []).length
                      if (plusCount > 1) {
                        value = '+' + sanitized.replace(/\+/g, '')
                      } else if (
                        plusCount === 1 &&
                        sanitized.indexOf('+') !== 0
                      ) {
                        value = '+' + sanitized.replace(/\+/g, '')
                      } else {
                        value = sanitized
                      }

                      changeField('personal', 'phone', value)
                    }}
                    pattern='[\+0-9]*'
                    inputMode='tel'
                    type='text'
                  />
                </InputWrapper>
              </CustomInputsRow>

              <CustomInputsRow column>
                <label>
                  Meio de contato preferêncial
                  <b> *</b>
                </label>
                <RadiosWrapper>
                  <GhostRadioV2
                    small
                    type='radio'
                    name='email'
                    label='Email'
                    selected={contact.value === 'e'}
                    onClick={() => {
                      changeField('personal', 'contact', 'e')
                    }}
                  />
                  <GhostRadioV2
                    small
                    type='radio'
                    name='phone'
                    label='Chamada telefónica'
                    selected={contact.value === 'p'}
                    onClick={() => {
                      changeField('personal', 'contact', 'p')
                    }}
                  />
                  <GhostRadioV2
                    small
                    type='radio'
                    name='sms'
                    label='SMS'
                    selected={contact.value === 's'}
                    onClick={() => {
                      changeField('personal', 'contact', 's')
                    }}
                  />
                </RadiosWrapper>
              </CustomInputsRow>

              {contact.value === 'p' && (
                <CustomInputsRow>
                  <WrapperSelect>
                    <InputLabel>
                      Em que período pretende ser contactado?
                    </InputLabel>
                    <StyledSelect
                      items={contactValues}
                      placeholder={'Selecionar o ciclo horário...'}
                      onChange={({ value }) =>
                        changeField('personal', 'contactTime', value)
                      }
                      selected={contactTime.value}
                      arrowIcon={ArrowIcon}
                    />
                    {Boolean(contactTime.valid) && (
                      <Error>{contactTime.valid}</Error>
                    )}
                  </WrapperSelect>
                </CustomInputsRow>
              )}
            </div>
          </InputsSection>
        </FormInputs>
        {renderBtns()}
      </Form>
    )
  )
}

export default PersonalForm



// WEBPACK FOOTER //
// ./src/components/JoinTariffModalV2/mobileComponents/personalForm.js